const intialState = {};

export default (state = intialState, action) => {
  switch (action.type) {
    case "updateRow":
      return { ...state, data: action.payload };
    default:
      return state;
  }
};